var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block font-mono text-xxs text-gray-500 uppercase tracking-wider",class:_vm.noMargin ? 'mb-0' : 'mb-4',on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }